var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},[_c('GenericBoxHeader',{attrs:{"variant":"highlight"}},[_vm._v("\n    Texto complementar\n  ")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.courseClass.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }